import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { ConfigurationTicketsListPage } from "./configuration-tickets-list/configuration-tickets-list";
import { TranslateService } from '@ngx-translate/core';
import { SalesListPage } from '../../sales/sales-list/sales-list';
import * as moment from 'moment';
import { SelectBetweenDatetime } from '../../components/popups/select-between-datetime/select-between-datetime';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { InvoicesCreateSelectTicketsPage } from '../../invoices/invoices-create/invoices-create-select-tickets/invoices-create-select-tickets';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the ConfigurationTicketsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-tickets',
    templateUrl: 'configuration-tickets.html',
})
export class ConfigurationTicketsPage {

    element_type: any = 'closed';
    searchbar_text: string = '';
    date_first: any;
    date_last: any;

    //datatable
    sorts = [
        { prop: 'number', dir: 'asc' },
        { prop: 'date', dir: 'asc' },
        { prop: 'cash_static', dir: 'asc' },
        { prop: 'type', dir: 'asc' },
        { prop: 'table_uid', dir: 'asc' },
        { prop: 'payment_type', dir: 'asc' },
        { prop: 'amount', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public configurationServices: ConfigurationServices,
        public globals: Globals,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        public toastCtrl: ToastController,
        public modalCtrl: ModalController) {

        this.globals.GAtrackView('Sales', 'Sales - Tickets - List', this.globals.restaurant.email, 'View', 'List tickets', 'Sales', '');
        this.configurationServices.tickets_searchbar_text = '';
        this.configurationServices.tickets_array_filtered = this.configurationServices.tickets_array_tmp;
        //init dates
        this.date_first = moment().subtract(2, "days").startOf('day').format('YYYY-MM-DDTHH:mm:ss');
        this.date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    }

    ionViewWillEnter() {

        if (!this.globals.checkLimitsByLicense('sales', 'tickets')) {
            this.navCtrl.pop();
            this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {

            let loadingPopup = this.loadingCtrl.create({
                spinner: 'crescent',
                content: this.translate.instant('instant-cargando-tickets')
            });
            loadingPopup.present();
            this.configurationServices.getNodeTickets(this.element_type, this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'));
            loadingPopup.dismiss();
        }
    }


    //funcion que abre el modal para seleccionar fechas
    openSelectDatetimeModal() {
        let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
            title: this.translate.instant('general-tickets-pagados'),
            date_first: this.date_first,
            date_last: this.date_last,
            cash_bool: false,

        });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.date_first = data.date_first;
                this.date_last = data.date_last;
                //
                this.searchTickets();
            }
        });
        profileModal.present();
    }

    //funcion que busca los tickets por las fechas elegidas
    searchTickets() {
        this.configurationServices.getNodeTickets(this.element_type, this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'));
    }

    //funcion que cambio el tipo de listado que queremos
    changeType(type) {
        this.element_type = type;
        this.configurationServices.getNodeTickets(this.element_type, this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'));
    }

    //
    trFontColor(ticket) {
        if ((ticket.refund && ticket.amount < 0) || (ticket.refund && ticket.refund_total)) {
            return 'text-danger';
        }
        return '';
    }

    openTicketOList(ticket) {
        this.navCtrl.push(ConfigurationTicketsListPage, {
            state: 'open',
            ticket: ticket,
        });
    }

    openTicketCList(ticket) {
        this.navCtrl.push(ConfigurationTicketsListPage, {
            state: 'closed',
            ticket: ticket,
        });
    }

    openSales() {
        this.navCtrl.push(SalesListPage);
    }

    createInvoice() {
        if (this.globals.checkLimitsByLicense('tpv', 'invoices')) {
            this.navCtrl.push(InvoicesCreateSelectTicketsPage, {
                date_first: this.date_first,
                date_last: this.date_last
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }


    clickElement(event) {
        if (event.type == 'click') {
            if (this.element_type === 'open') {
                this.navCtrl.push(ConfigurationTicketsListPage, {
                    state: 'open',
                    ticket: event.row,
                });
            } else if (this.element_type === 'closed') {
                this.navCtrl.push(ConfigurationTicketsListPage, {
                    state: 'closed',
                    ticket: event.row,
                });
            }
        }
    }

    onSort(event) {
        var tickets_array = this.configurationServices.tickets_array_tmp;

        switch (event.column.name) {
            case 'number':
                if (event.newValue == 'asc') {
                    tickets_array.sort((a, b) => a.number - b.number);
                } else {
                    tickets_array.sort((a, b) => b.number - a.number);
                }
                break;
            case 'date':
                if (event.newValue == 'asc') {
                    tickets_array.sort((a, b) => this.globals.timestampToDate(a.date).localeCompare(this.globals.timestampToDate(b.date)));
                } else {
                    tickets_array.sort((a, b) => this.globals.timestampToDate(b.date).localeCompare(this.globals.timestampToDate(a.date)));
                }
                break;
            case 'cash_static':
                if (event.newValue == 'asc') {
                    tickets_array.sort((a, b) => a.cash_static.localeCompare(b.cash_static));
                } else {
                    tickets_array.sort((a, b) => b.cash_static.localeCompare(a.cash_static));
                }
                break;
            case 'type':
                if (event.newValue == 'asc') {
                    tickets_array.sort((a, b) => a.type.localeCompare(b.type));
                } else {
                    tickets_array.sort((a, b) => b.type.localeCompare(a.type));
                }
                break;
            case 'table_uid':
                if (event.newValue == 'asc') {
                    tickets_array.sort((a, b) => a.table_uid.slice(-4).toUpperCase().localeCompare(b.table_uid.slice(-4).toUpperCase()));
                } else {
                    tickets_array.sort((a, b) => b.table_uid.slice(-4).toUpperCase().localeCompare(a.table_uid.slice(-4).toUpperCase()));
                }
                break;
            case 'payment_type':
                if (event.newValue == 'asc') {
                    tickets_array.sort((a, b) => a.payment_type.localeCompare(b.payment_type));
                } else {
                    tickets_array.sort((a, b) => b.payment_type.localeCompare(a.payment_type));
                }
                break;
            case 'amount':
                if (event.newValue == 'asc') {
                    tickets_array.sort((a, b) => a.amount - b.amount);
                } else {
                    tickets_array.sort((a, b) => b.amount - a.amount);
                }
                break;
        }

        this.configurationServices.tickets_array_tmp = tickets_array;
    }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-tickets/configuration-tickets.ts